var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isCallMessage && _setup.conversationType === _setup.TYPES.CONV_GROUP)?_c('div',{class:{ blinkText: _setup.isBlink }},[_vm._v(" "+_vm._s(_setup.custom)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }